import { en } from "./en";

export const locales = {
  en,
};
